<template></template>

<script>
/*
    props
    -----

    productId - the id of the product
    attributeId - the id of the attribute
    versionId - the id of the currently selected version.

    methods
    -------

    handleNewValue(newValue:String)
    handleNewValueWithSync(newValue:String)

    events
    ------

    in-progress: a call has been made
    success: the call is complete. success
    error: the call is complete. with error
    new-value-created: the create new option call is complete
*/

import axios from 'axios';
import moment from 'moment';

export default {
    name: 'product-details-attributes-api-handler',
    props: {
        productId: Number,
        attributeId: Number,
        versionId: Number,
    },
    data() {
        return {};
    },
    methods: {
        handleNewValue(newValue) {
            this.saveNewValue(newValue, false);
        },
        handleNewValueWithSync(newValue) {
            this.saveNewValue(newValue, true);
        },
        saveNewValue(newValue, withSync) {
            let base_url = window.location.protocol + "//" + window.location.host

            this.$emit('in-progress');
            axios.post(base_url + '/pimapi/products/' + this.productId + '/attributes/' + this.attributeId + '/version/' + this.versionId, {
                "sync": withSync,
                "value": newValue
            })
            .then((response) => {
                this.$emit('success', response);
            })
            .catch((error) => {
                if (error.response) {
                    this.$emit('error', error.response.data);
                } else {
                    this.$emit('error', error);
                }
            });
        },
        scheduleNewValue(newValue, scheduleTo) {
            let base_url = window.location.protocol + "//" + window.location.host;

            this.$emit('in-progress');
            axios.post(base_url + '/pimapi/products/' + this.productId + '/attributes/' + this.attributeId + '/version/' + this.versionId + '/schedule', {
                "scheduleTo": scheduleTo,
                "value": newValue
            })
            .then((response) => {
                this.$emit('success', response);
            })
            .catch((error) => {
                if (error.response) {
                    this.$emit('error', error.response.data);
                } else {
                    this.$emit('error', error);
                }
            });
        }
    }
}
</script>
